import { LegalPage, LegalH2 } from "@/components/LegalPage";

export default function DeliveryReturn() {
  return (
    <LegalPage title="Teslimat ve İade Şartları" updated="15.08.2026" testid="delivery-return-page">
      <LegalH2>Teslimat</LegalH2>
      <p>
        Sunduğumuz hizmet dijital prodüksiyon hizmetidir; fiziksel kargo teslimatı yapılmaz. Tamamlanan
        proje çıktıları (senaryo ve film dosyaları) portal üzerinden ve/veya e-posta ile paylaşılan
        güvenli bağlantılar aracılığıyla dijital olarak teslim edilir.
      </p>
      <p>
        Teslim süresi, kabul edilen teklifte belirtilen süredir. Ön ödemenin alınmasının ardından proje
        “Üretimde” statüsüne geçer ve süreç tamamlandığında “Teslim” aşamasına alınır.
      </p>

      <LegalH2>İade ve İptal Koşulları</LegalH2>
      <p>
        Hizmetlerimiz projeye/kişiye özel olarak üretildiğinden, üretime başlandıktan sonra iade
        yapılamaz. Aşağıdaki durumlar geçerlidir:
      </p>
      <p>
        • <b>Üretime başlanmadan önce:</b> ALICI iptal talep ederse, yapılan ön hazırlık maliyetleri
        düşülerek kalan tutar iade edilir.<br />
        • <b>Üretim başladıktan sonra:</b> Hizmet kişiye özel üretildiğinden ön ödeme iade edilmez.<br />
        • <b>Teslim sonrası:</b> Teslim edilen işte sözleşmeye aykırı bir durum varsa, makul sayıda
        revizyon hakkı kapsamında düzeltme yapılır.
      </p>

      <LegalH2>Ücret İadesi</LegalH2>
      <p>
        İade edilmesi kararlaştırılan tutarlar, iade talebinin onaylanmasını takiben iyzico üzerinden,
        ödemenin yapıldığı karta <b>10 iş günü</b> içerisinde iade edilir.
      </p>

      <LegalH2>İletişim</LegalH2>
      <p>
        İptal ve iade talepleriniz için: info@incefikirler.tv — +90 532 176 74 41
      </p>
    </LegalPage>
  );
}
